<template>
  <div class="aside__block">
    <div class="aside__subblock">
      <div class="aside__list">
        <div class="aside__item -full-">
          <Avatar :img="user.avatar" circle="circle"></Avatar>
        </div>
        <div class="aside__item">
          <Input title="Имя" :value="user.name" :disabled="true"></Input>
        </div>
        <div class="aside__item">
          <Input title="Фамилия" :value="user.lastname" :disabled="true"></Input>
        </div>
        <div class="aside__item">
          <Input title="Email" :value="user.email" :disabled="true"></Input>
        </div>
        <div class="aside__item">
          <Input title="Телефон" :value="user.phone" :disabled="true"></Input>
        </div>
        <div class="aside__item">
          <Input title="Город" :value="user.city" :disabled="true"></Input>
        </div>
        <div v-if="user.vkLink || user.fbLink || user.instaLink" class="aside__item -full-">
          <InlineSocials
            :vk="user.vkLink"
            :fb="user.fbLink"
            :insta="user.instaLink"
          ></InlineSocials>
        </div>
        <div class="aside__item -full-">
          <TextArea
            title="Информация о бизнесе"
            :value="user.businessInfo"
            :disabled="true"
          ></TextArea>
        </div>
        <div class="aside__item -full-">
          <Input
            title="Сфера бизнеса"
            :value="getBusinessCategory(user.businessCategoryId)"
            :disabled="true"
          ></Input>
        </div>
        <div class="aside__item">
          <Input title="Город" :value="user.businessCity" :disabled="true"></Input>
        </div>
        <div v-if="user.businessLocationTypeId" class="aside__item">
          <Input
            title="Размещение"
            :value="getBusinessLocation(user.businessLocationTypeId)"
            :disabled="true"
          ></Input>
        </div>
        <div class="aside__item">
          <Input
            title="Прибыль в неделю"
            type="number"
            icon="ruble"
            :value="user.profitPerWeek"
            :disabled="true"
          ></Input>
        </div>
        <div class="aside__item -full-">
          <TextArea
            title="Франшизы (города присутствия)"
            :value="user.franchises"
            :disabled="true"
          ></TextArea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InlineSocials from '@/components/InlineSocials';
import { mapState } from 'vuex';

export default {
  components: { InlineSocials },
  computed: {
    ...mapState('usersGroups', {
      user: s => s.aside.data.user
    }),
    ...mapState('auth', {
      storeBusinessTypes: s => s.data.businessTypes
    }),
    businessTypes() {
      return this.storeBusinessTypes.map(item => {
        return {
          text: item.text,
          id: item.id
        };
      });
    }
  },
  destroyed() {
    this.$store.dispatch('usersGroups/setAsideMeta', {
      path: 'isUserOpen',
      value: false
    });
    this.$store.dispatch('usersGroups/setAsideData', {
      path: 'user',
      value: {}
    });
  },
  methods: {
    getBusinessCategory(id) {
      const cat = this.businessTypes.find(el => el.id === id);
      return cat ? cat.text : 'Нет бизнеса';
    },
    getBusinessLocation(id) {
      if (!id) {
        return '';
      }

      switch (+id) {
        case 1:
          return 'Онлайн';
        case 2:
          return 'Офлайн';
        case 3:
          return 'Совмещенный';
        default:
          return '';
      }
    }
  }
};
</script>
